
export default function AlbumCover(props) {
  return (
    <div className="album-cover" style={{ backgroundImage: `url(${props.src})` }}>
    </div>
  );
}